import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class G2Service {
  path = 'user/g2_token';

  constructor(
    private apiService: ApiService
  ) {}

  getG2Token(): Observable<any> {
    return this.apiService.get(this.path);
  }
}

